var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJava(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.725,
    height: 32,
    viewBox: "0 0 23.725 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Untitled-1",
    transform: "translate(-4.655 -2.093)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M10.338,18.751s-1.229.711.875.951a18.484,18.484,0,0,0,6.66-.281,11.671,11.671,0,0,0,1.772.859C13.347,22.964,5.392,20.125,10.338,18.751Zm-.77-3.5s-1.379,1.017.727,1.234a26.148,26.148,0,0,0,8.6-.41,3.813,3.813,0,0,0,1.323.8c-7.613,2.214-16.094.173-10.646-1.625Z",
    transform: "translate(1.957 8.089)",
    fill: "#0074bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M13.468,14.9c1.552,1.777-.407,3.375-.407,3.375S17,16.258,15.193,13.724c-1.691-2.363-2.988-3.537,4.028-7.584,0,0-11.013,2.736-5.753,8.765Z",
    transform: "translate(4.545 2.489)",
    fill: "#ea2d2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M26.342,22.84s.911.746-1,1.324c-3.634,1.093-15.129,1.424-18.322.044-1.147-.5,1-1.187,1.683-1.332a4.424,4.424,0,0,1,1.108-.124c-1.276-.893-8.249,1.757-3.542,2.516C19.106,27.337,29.672,24.335,26.342,22.84ZM12.887,13.117S7.041,14.5,10.816,15a44.038,44.038,0,0,0,7.734-.082c2.419-.2,4.848-.635,4.848-.635a10.235,10.235,0,0,0-1.47.783c-5.938,1.554-17.407.83-14.106-.759A11.1,11.1,0,0,1,12.887,13.117Zm10.488,5.83c6.037-3.117,3.246-6.116,1.3-5.712a4.381,4.381,0,0,0-.69.186,1.09,1.09,0,0,1,.517-.4c3.852-1.347,6.815,3.973-1.244,6.082a.531.531,0,0,0,.12-.158Z",
    transform: "translate(0 6.591)",
    fill: "#0074bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M16.825,2.093s3.343,3.327-3.17,8.44c-5.223,4.1-1.19,6.442,0,9.115C10.6,16.914,8.367,14.5,9.867,12.263c2.2-3.291,8.306-4.887,6.957-10.17Z",
    transform: "translate(2.911 0)",
    fill: "#ea2d2e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M11.852,22.962c5.791.368,14.689-.205,14.9-2.933,0,0-.4,1.034-4.787,1.854A47.858,47.858,0,0,1,7.3,22.108s.741.61,4.548.854Z",
    transform: "translate(1.629 11.031)",
    fill: "#0074bd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJava);
export default __webpack_public_path__ + "static/media/java.8c2478cc95019439865257f73c5899d3.svg";
export { ForwardRef as ReactComponent };